<template lang="pug">
#header-container
    #header.fixed-top(:style='aplicarZindex()')
        #logo-wrapper(v-if='logoUrlDefault')
            img#logo-lyra(src='@/assets/lyra-logo.svg')

        #logo-wrapper-bunge(v-else)
            img#logo-bunge(:src='logoUrlCustom')

        #language-dropdown
            el-dropdown.el-dropdown-div
                span.el-dropdown-link
                    i.el-icon-s-grid.language-icon
                    span.language-name {{ selectedLanguageName }}
                    i.icon-arrow-lang.el-icon-arrow-down.el-icon--right
                el-dropdown-menu(slot='dropdown')
                    el-dropdown-item.language-item(@click.native='switchLanguage("pt-BR")')
                        span.flag-icon 🇧🇷
                        span.language-label Português
                        span.language-code (pt-br)
                    el-dropdown-item.language-item(@click.native='switchLanguage("en")')
                        span.flag-icon 🇺🇸
                        span.language-label English
                        span.language-code (en)
                    el-dropdown-item.language-item(@click.native='switchLanguage("es")')
                        span.flag-icon 🇪🇸
                        span.language-label Español
                        span.language-code (es)

        #notification-button(@click='toggleNotificationPanel')
            el-badge.notification-badge(:value='unreadNotificationsCount', :max='99', :hidden='unreadNotificationsCount === 0')
                i.el-icon-bell.notification-icon

        #user-logged
            el-dropdown
                span.el-dropdown-link
                    div
                        i.user-logo.mdi.mdi-account-circle
                    span.dados_user
                        .username {{ userNameFormated(user.nome) }}
                        .empresa-selecionada {{ user.nameGroup }}
                    i.icon-arrow-user.el-icon-arrow-down.el-icon--right
                el-dropdown-menu(slot='dropdown')
                    el-dropdown-item {{ user.perfil }}
                    el-dropdown-item(
                        v-if='verificarEmpresas()',
                        @click.native='trocarPerfil'
                    )
                        | {{ $t('mensagens.comuns.trocarPerfil') }}
                    el-dropdown-item.sair(
                        divided='',
                        @click.native='logout',
                        icon='el-icon-arrow-left'
                    )
                        | {{ $t('mensagens.comuns.sair') }}

    ModalAmbienteIdioma(
        :show='isModalAmbiente',
        :empresas='user.grupos',
        @close='closeModalAmbiente',
        @alterarAmbiente='alterarAmbiente',
        style='z-index: 4001'
    )
</template>

<script>
import { CULTURAS } from '@/utils/TipoCultura';
import keycloakUtil from '@/utils/keycloak';
import { mapGetters, mapState, mapActions } from 'vuex';

import authService from '@/services/AuthService';
import userService from '@/services/UsuarioService';
import store from '@/store';

import locale from 'elementui-lts/lib/locale';
import langPt from 'elementui-lts/lib/locale/lang/pt-br';
import langEn from 'elementui-lts/lib/locale/lang/en';
import langEs from 'elementui-lts/lib/locale/lang/es';

import ModalAmbienteIdioma from '@/components/layout/ModalAmbienteIdioma.vue';

import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'MenuSuperior',

    components: {
        ModalAmbienteIdioma
    },

    data() {
        return {
            CULTURAS,
            user: {
                nome: '',
                nameGroup: '',
                perfil: '',
                locale: '',
                id: '',
                paisGrupo: '',
                grupos: []
            },
            ambientes: AmbientesEmpresas,
            logoUrlDefault: false,
            logoUrlCustom: null,
            selectedLanguageName: '',
            ambienteLabel: '',
            isModalAmbiente: false,
            setEmitGrupoSelecionado: false,
            unreadNotificationsCount: 0
        };
    },

    props: {
        route: {
            type: String
        },
        routeParams: {
            type: Object,
            required: true
        }
    },

    computed: {
        ...mapGetters({
            culturaSelecionada: 'culturaSelecionada',
            abaSelecionadaAreaMonitorada: 'abaSelecionadaAreaMonitorada'
        }),
        ...mapState(['usuarioLogado'])
    },

    mounted() {
        this.switchSelectedLanguage(this.$i18n.locale);
        this.loadUserData();
        this.updateUnreadCount();

        // Escuta eventos de atualização de notificações
        this.$root.$on('notifications-updated', this.updateUnreadCount);
        this.$root.$on('notifications-read', this.updateUnreadCount);
    },

    beforeDestroy() {
        this.$root.$off('notifications-updated', this.updateUnreadCount);
        this.$root.$off('notifications-read', this.updateUnreadCount);
    },

    methods: {
        ...mapActions(['limparCamadasPermitidasPorUsuario']),

        toggleNotificationPanel() {
            this.$root.$emit('toggle-notification-panel');
        },

        updateUnreadCount() {
            try {
                const stored = localStorage.getItem('systemNotifications');
                if (stored) {
                    const notifications = JSON.parse(stored);
                    this.unreadNotificationsCount = notifications.filter(n => !n.read).length;
                } else {
                    this.unreadNotificationsCount = 0;
                }
            } catch (error) {
                this.unreadNotificationsCount = 0;
            }
        },

        changeLocaleElementUI(i18nLocale) {
            switch (i18nLocale) {
                case 'en':
                    locale.use(langEn);
                    break;
                case 'pt-BR':
                    locale.use(langPt);
                    break;
                case 'es':
                    locale.use(langEs);
                    break;
                default:
                    locale.use(langPt);
            }
        },

        aplicarZindex() {
            if (this.$route.name === 'operacaoDashboard') {
                return { 'z-index': '3001' };
            }
        },

        goToInicio() {
            this.$store.commit('SET_CULTURA_SELECIONADA', null);
            this.$store.dispatch('limparFiltro');
            if (this.$route.name !== 'Home') {
                this.$router.push({ name: 'Home' });
            } else {
                this.$router.go();
            }
        },

        switchSelectedLanguage(lang) {
            const languageNames = {
                'pt-BR': 'Português',
                en: 'English',
                es: 'Español'
            };

            this.selectedLanguageName = languageNames[lang];
        },

        switchLanguage(lang) {
            this.switchSelectedLanguage(lang);
            if (this.user && this.user.id) {
                userService.updateUserLocale(this.user.id, lang).then(() => {
                    this.$i18n.locale = lang;
                });
            }

            this.changeLocaleElementUI(this.$i18n.locale);
            this.$setLocaleElementUI(lang);
        },

        logout() {
            window.location.href = keycloakUtil.getLogoutUrl();
            store.dispatch('clearMarcarExportar_PDF', null);
            store.dispatch('setUsuarioLogado', null);
        },

        verificarEmpresas() {
            if (this.user.grupos && this.user.grupos.length > 1) {
                return true;
            } else {
                return false;
            }
        },

        trocarPerfil() {
            this.isModalAmbiente = true;
        },

        closeModalAmbiente() {
            this.isModalAmbiente = false;
        },

        async alterarAmbiente(novoAmbiente) {
            if (this.user.paisGrupo === novoAmbiente) return;
            this.ambienteLabel = novoAmbiente;
            this.updateGrupoSelecionado(novoAmbiente);
            this.closeModalAmbiente();
        },

        async updateGrupoSelecionado(nomeGrupo) {
            const refreshToken = sessionStorage.getItem('refreshToken');

            await userService
                .atualizarGrupoSelecionado(nomeGrupo, refreshToken)
                .then(({ data }) => {
                    sessionStorage.setItem('jwtToken', data.access_token);
                    sessionStorage.setItem('refreshToken', data.refresh_token);
                    this.user.nameGroup = nomeGrupo;
                    this.setEmitGrupoSelecionado = true;
                    this.loadUserData();
                    this.limparCamadasPermitidasPorUsuario();
                    this.goToInicio();
                });
        },

        loadUserData() {
            authService
                .isLogged()
                .then(({ data }) => {
                    store.dispatch('setUsuarioLogado', data);
                    if (this.setEmitGrupoSelecionado) {
                        this.$emit('updateGrupoSelecionado');
                        this.setEmitGrupoSelecionado = false;
                    }
                    this.user.nome = data.nome;
                    this.user.locale = data.locale;
                    this.user.id = data.idKeyCloack;
                    this.user.nameGroup = data.nameGroup;
                    if (data.isAnalyst) {
                        this.user.perfil = this.$t(
                            'mensagens.menuSuperior.perfil.analista'
                        );
                    } else if (data.isRegular) {
                        this.user.perfil = this.$t(
                            'mensagens.menuSuperior.perfil.cliente'
                        );
                    } else if (data.isAdmin) {
                        this.user.perfil = this.$t(
                            'mensagens.menuSuperior.perfil.administrador'
                        );
                    }

                    this.user.paisGrupo = data.paisGrupo;
                    this.user.grupos = data.grupos;

                    store.dispatch(
                        'updateUsuarioLogadoAmbiente',
                        data.paisGrupo
                    );

                    if (data.logoUrl) {
                        this.setLogoAplicacao(data);
                    } else {
                        this.logoUrlDefault = true;
                    }
                })
                .catch(erro => {
                    this.$notify.error({
                        message: this.$t('mensagens.menuSuperior.erro')
                    });
                });
        },

        setLogoAplicacao(data) {
            let logoUrl = null;

            if (this.$i18n._vm.locale === 'en') {
                logoUrl = data.logoUrlIngles;
            }

            if (this.$i18n._vm.locale === 'es') {
                logoUrl = data.logoUrlEspanhol;
            }

            this.logoUrlCustom = logoUrl || data.logoUrl;
        },

        userNameFormated(userName) {
            if (userName) {
                if (userName.length > 13) {
                    return userName.substring(0, 13) + '...';
                }
                return userName;
            }
        }
    },
    watch: {
        '$i18n._vm.locale': function () {
            this.setLogoAplicacao(this.usuarioLogado);
        }
    }
};
</script>

<style lang="scss" scoped>
$width-box-tipo-cultura: 115px;

#language-dropdown {
    color: var(--white);
    margin-right: 15px;
    margin-left: auto;
    width: auto;
    display: flex;
    align-items: center;
    cursor: pointer;

    .language-icon {
        color: white;
        font-size: 18px;
        margin-right: 8px;
    }

    span.language-name {
        color: white;
        font-size: 14px;
        margin-right: 4px;
    }

    .icon-arrow-lang {
        color: white;
    }
}

.language-item {
    display: flex;
    align-items: center;
    padding: 8px 16px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: #f5f7fa;
    }

    .flag-icon {
        font-size: 20px;
        margin-right: 10px;
        min-width: 24px;
        text-align: center;
    }

    .language-label {
        flex: 1;
        font-size: 14px;
        color: #303133;
        font-weight: 500;
    }

    .language-code {
        font-size: 11px;
        color: #909399;
        font-weight: normal;
        margin-left: 8px;
    }
}

#header {
    height: 65px;
    background-color: var(--primary);
    box-shadow: 0px 3px 5px 0px var(--block-shadow);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.username {
    color: var(--white);
    cursor: pointer;
    font-size: 14px;
}

.el-dropdown-link {
    display: flex;
    align-items: center;
}

.user-logo {
    color: var(--white);
    font-size: 28px;
    margin-right: 5px;
}

.icon-arrow-user {
    color: var(--white);
}

.sair {
    color: var(--primary);
}

#header-monitoramento {
    .flow {
        font-size: 20px;

        &.tilted {
            transform: rotate(45deg);
        }
    }
}

.box {
    display: flex;
    justify-content: center;
    height: 100%;
    min-width: 420px;

    .tipo {
        font-size: map-get($font-size, big);
        height: 100%;

        display: flex;
        justify-content: center;
        align-items: center;

        border-bottom: 2px solid transparent;

        color: var(--white);

        &.active {
            color: var(--secondary);
            border-bottom: 3px solid var(--secondary);

            h6 {
                font-weight: map-get($font-weight, medium);
            }

            i {
                color: var(--secondary);
            }
        }

        i {
            color: var(--disabled-font-color);
        }
    }

    .tipo.cultura {
        width: $width-box-tipo-cultura;
    }

    .tipo.area-monitorada {
        padding: 0 3%;
    }

    &.box-area-monitorada {
        .flow {
            font-size: 26px;
        }
    }
}

#logo-wrapper {
    height: 36px;
    max-width: 650px;
    clip-path: polygon(0 0, 100% 0%, 95% 100%, 0% 100%);
    margin-left: 51px;

    #logo-lyra {
        max-width: 100%;
    }
}

#logo-wrapper-bunge {
    height: 36px;
    max-width: 650px;
    margin-left: 30px;

    #logo-bunge {
        max-width: 100%;
        height: 36px;
    }
}

#user-logged {
    color: var(--white);
    margin-right: 12px;
    display: flex;
    align-items: center;
    cursor: context-menu;

    span {
        font-size: 14px;
        margin-right: 4px;
    }
}

.action-button {
    cursor: pointer;
}
.dados_user {
    width: 110px;
    display: flex;
    flex-direction: column;
    align-items: left;

    .username {
        color: var(--white);
        cursor: pointer;
        font-size: 14px;
    }
    .empresa-selecionada {
        color: var(--white);
        max-width: 16ch;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
        font-size: 12px;
    }
}

#notification-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    cursor: pointer;
    padding: 8px;
    border-radius: 4px;
    transition: background-color 0.2s;

    &:hover {
        background-color: rgba(255, 255, 255, 0.1);
    }

    .notification-badge {
        line-height: 1;
    }

    .notification-icon {
        font-size: 22px;
        color: white;
    }
}
</style>
